import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const formScheme: ItemScheme[] = [
    {
        type: MagicField.CONTAINER,
        key: 'againstBcg',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.bcg',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstHvB',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.hvb',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstCovid',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.covid',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstDt',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.dt',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstDpta',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.dpta',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstYellowFever',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.yellowFever',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstAdultHepatitisB',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.adultHepatitisB',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstHepatitisA',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.hepatitisA',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstPediatricHepatitisA',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.pediatricHepatitisA',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstHerpesZoster',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.herpesZoster',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstPediatricInfluenza',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.pediatricInfluenza',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstAdultInfluenza',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.adultInfluenza',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstMeningococcusCombined',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.meningococcusCombined',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstMeningococcusPoly',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.meningococcusPoly',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstBabyPneumococcus',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.pneumococcus',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'pentavalent',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.pentavalentVaccine',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstPoliomyelitisInactivated',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.poliomyelitisInactivated',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstPoliomyelitis',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.poliomyelitis',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstRabies',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.rabies',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstRotavirus',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.rotavirus',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstSr',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.sr',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstSpr',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.spr',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstChickenpox',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.chickenpox',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'againstPapillomaVirus',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.papillomaVirus',
            },
        ]
    },
    {
        type: MagicField.CONTAINER,
        key: 'others',
        children: [
            {
                type: MagicField.CHECKBOX,
                key: 'toggle',
                label: 'component.vaccination.others',
            },
            {
                type: MagicField.CONDITION,
                settings: {
                    rules: [
                        {
                            formControlKey: 'others.toggle',
                            rule: 'equal',
                            value: true,
                        },
                    ],
                },
                children: [
                    {
                        type: MagicField.CONTAINER,
                        settings: {
                            showLine: true,
                        },
                        children: [
                            {
                                type: MagicField.TEXT_FIELD,
                                key: 'description',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export default formScheme;
